import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";


const LandUses: string[] = [
    "All Surveys",
    "A1 - Retail Park",
    "A1 - Other Use",
    "A1 - Internet Cafe",
    "A1 - Mixed Use Commercial",
    "A1 - Retail Warehouse",
    "A1 - Garden Centre",
    "A1 - Supermarket",
    "A3 - Restaurant",
    "A3 - Cafe",
    "A4 - Public House",
    "A4 - Wine Bar",
    "A5 - Take Away/Fast Food",
    "B1 - Office",
    "B1 - Studio",
    "B1 - Light Industrial",
    "B2 - General Industry",
    "B8 - Storage",
    "C1 - Hotel",
    "C1 - Hostel & Halls of Residence",
    "C2 - Residential Care",
    "C2 - Residential School",
    "C2 - Hospital",
    "C3 - Mixed Use Residential",
    "C3 - Residential",
    "D1 - Other Use",
    "D1 - Day Nurseries",
    "D1 - Non-Residential School",
    "D1 - Health Service",
    "D2 - Health Clubs & Sports Centres",
    "D2 - Bingo",
    "D2 - Bowling",
    "D2 - Other Use",
    "D2 - Cinema",
    "D2 - Leisure Complex",
    "SG - Petrol Stations",
    "SG - Car Showroom",
    "SG - Theatre",
    "SG - Construction Site",
    "SG - Mini-cab offices",
    "SG - Other Use",
    "SG - Nightclubs"
];

interface IProps {
    selectedValue: string;
    setSelectedValue: (value: string) => void;
    continueAction: () => void;
    disableButton: boolean;
}

export default function TravlLandUseDropdown({ selectedValue, setSelectedValue, continueAction, disableButton }: IProps) {
    const landUseDropDown = [...LandUses];
   
    return (
        <Grid container size={4}>
            <Grid size={7}>
                <TextField
                    label="Main Land Use"
                    select
                    fullWidth
                    size='small'
                    value={selectedValue}
                    onChange={(e) => setSelectedValue(e.target.value)}
                    SelectProps={{
                        MenuProps: {
                            PaperProps: {
                                style: {
                                    maxHeight: 350,
                                    padding: 0,
                                }
                            },
                            MenuListProps: {
                                dense: true,
                                sx: {
                                    padding: 0,
                                },
                            },
                        }
                    }}
                >
                    {landUseDropDown
                        .map((value) => (
                            <MenuItem key={value} value={value}>{`${value}`}</MenuItem>
                        ))
                    }
                </TextField>
            </Grid>

            <Grid size={5}>
                <Button disabled={disableButton} onClick={continueAction}>Continue</Button>
            </Grid>
           
        </Grid>
    )
}